import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import Otp from './Otp'
import callApi from 'services/api'
import { loadingState } from 'global/LoaderState'
import { useRecoilState } from 'recoil'
import { AlertState } from 'global/AlertState'
import { encryptByRSA } from 'utils/CryptoUtils'
const ForgotPasswordForm = ({ setLoginActiveView }) => {
  const [handleClick, setHandleClick] = useState(false)
  const [formData, setFormData] = useState(null)
  const [, setAlertMessage] = useRecoilState(AlertState)
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues: {
      registrationNumber: '',
    },
    validationSchema: Yup.object({
      registrationNumber: Yup.string().required(
        'Please enter your Registration No., Phone No., or Email ID.'
      ),
    }),
    onSubmit: async (values) => {
      const encryptedData = encryptByRSA(values.registrationNumber)
      setLoading(true)
      const response = await callApi(
        'auth/forget-password',
        'POST',
        encryptedData,
        false,
        false,
        setAlertMessage,
        null,
        null
      )
      setLoading(false)
      if (response?.success) {
        setFormData({ registrationNumber: values?.registrationNumber })
        setHandleClick(true)
      } else {
      }
    },
  })

  const handleEditRegistrationNumber = () => {
    setHandleClick(false)
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-8">
        <div className="card">
          <div className="card-face card-front">
            <div className="card-body">
              <h3 className="card-title">Forgot Password</h3>
              {!handleClick ? (
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <label
                      htmlFor="registrationNumber"
                      className="form-label mt-3"
                    >
                      Username:
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="registrationNumber"
                      name="registrationNumber"
                      className={`form-control ${
                        formik.touched.registrationNumber &&
                        formik.errors.registrationNumber
                          ? 'is-invalid'
                          : ''
                      }`}
                      {...formik.getFieldProps('registrationNumber')}
                      placeholder="Username"
                      autoComplete="Username"
                    />
                    {formik.touched.registrationNumber &&
                      formik.errors.registrationNumber && (
                        <div className="invalid-feedback">
                          {formik.errors.registrationNumber}
                        </div>
                      )}
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className="btn btn-info w-100"
                      disabled={loading}
                    >
                      {loading && (
                        <>
                          <FontAwesomeIcon icon={faSpinner} className="me-2" />
                        </>
                      )}
                      Forgot Password
                    </button>
                  </div>
                </form>
              ) : (
                <Otp
                  registrationNumber={formData?.registrationNumber}
                  onEdit={handleEditRegistrationNumber}
                  setLoginActiveView={setLoginActiveView}
                />
              )}
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-link"
                  onClick={() => setLoginActiveView('login')}
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordForm
